/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

const CustomScrollbars = (props) => (
  <Scrollbars
    {...props}
    autoHide
    renderTrackHorizontal={
      (trackProps) => <div {...trackProps} style={{ display: 'none' }} className="track-horizontal" />
    }
  />
);

export default CustomScrollbars;
